import type { VenueBookingPhoto } from '../../../../../api/venues';
import { SourceChip } from '../SourceChip';

/** Who the current photo came from, or a pill saying there is none yet. */
export function PhotoSourceLine({
  source,
  who,
}: {
  source: VenueBookingPhoto['source'];
  who: string | null;
}) {
  if (source === null) {
    return (
      <span className="nb-pill" style={{ height: 20, fontSize: 10.5, fontWeight: 700, gap: 5 }}>
        No photo yet
      </span>
    );
  }
  return <SourceChip kind="photo" source={source === 'staff' ? 'staff' : 'fareharbor'} who={who} />;
}
